import { useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { Box } from "@mui/system";
import FilterComponent from "../../../../../../../../ReusableFIlterComponent/FilterComponent";
import {
  setSelectedAdGroupForMissingCrossNegatives,
  setSelectedCampaignForMissingCrossNegatives,
  setSelectedKeywordForMissingCrossNegatives,
} from "../../../../../../../../../features/searchTermTabSlice";

export default function STMissingCrossNegativesFilterItems({
  clearSelectedSearchTerm,
}: any) {
  const {
    stMissingCrossNegatives,
    selectedCampaignForMissingCrossNegatives,
    selectedAdGroupForMissingCrossNegatives,
    selectedKeywordForMissingCrossNegatives
  } = useSelector((state: any) => state.searchTermTab);

  const dispatch = useDispatch();

  const [searchAdgroups, setSearchAdgroups] = useState("");
  const [searchCampaigns, setSearchCampaigns] = useState("");
  const [searchKeywords, setSearchKeywords] = useState("");
  const filterConfig = [
    {
      key: "CampaignForMissingCrossNegatives",
      name: "Campaign",
      label: "Select one or more Campaigns",
      searchTerm: searchCampaigns,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchCampaigns(e.target.value),
      selectedOption: selectedCampaignForMissingCrossNegatives,
      filterName: "campaign_name",
      data: stMissingCrossNegatives,
      onSelectionChange: (updatedSelection: any) =>
        dispatch(setSelectedCampaignForMissingCrossNegatives(updatedSelection)),
      count:
        selectedCampaignForMissingCrossNegatives &&
        selectedCampaignForMissingCrossNegatives.length,
      colorSelected:
        selectedCampaignForMissingCrossNegatives !== null &&
        selectedCampaignForMissingCrossNegatives.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
    {
      key: "AdgroupForMissingCrossNegatives",
      name: "Adgroup",
      label: "Select one or more Adgroups",
      searchTerm: searchAdgroups,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchAdgroups(e.target.value),
      selectedOption: selectedAdGroupForMissingCrossNegatives,
      filterName: "adgroup_name",
      data: stMissingCrossNegatives,
      onSelectionChange: (updatedSelection: any) =>
        dispatch(setSelectedAdGroupForMissingCrossNegatives(updatedSelection)),
      count:
        selectedAdGroupForMissingCrossNegatives &&
        selectedAdGroupForMissingCrossNegatives.length,
      colorSelected:
        selectedAdGroupForMissingCrossNegatives !== null &&
        selectedAdGroupForMissingCrossNegatives.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
    {
      key: "KeywordsForMissingCrossNegatives",
      name: "Keyword",
      label: "Select one or more Keywords",
      searchTerm: searchKeywords,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchKeywords(e.target.value),
      selectedOption: selectedKeywordForMissingCrossNegatives,
      filterName: "keyword_name",
      data: stMissingCrossNegatives,
      onSelectionChange: (updatedSelection: any) =>
        dispatch(setSelectedKeywordForMissingCrossNegatives(updatedSelection)),
      count:
        selectedKeywordForMissingCrossNegatives &&
        selectedKeywordForMissingCrossNegatives.length,
      colorSelected:
        selectedKeywordForMissingCrossNegatives !== null &&
        selectedKeywordForMissingCrossNegatives.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
  ];

  const clearFilters = () => {
    dispatch(setSelectedCampaignForMissingCrossNegatives([]));
    dispatch(setSelectedAdGroupForMissingCrossNegatives([]));
    dispatch(setSelectedKeywordForMissingCrossNegatives([]));
    clearSelectedSearchTerm(null);
    setSearchAdgroups("");
    setSearchCampaigns("");
    setSearchKeywords("");
  };

  return (
    <Box data-tracker="548" sx={{ position: "relative" }}>
      <FilterComponent
        filterConfig={filterConfig}
        clearFilters={clearFilters}
      />
    </Box>
  );
}
